var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "distance-bucket-label w-100" }, [
    _vm._v("\n    Greater than " + _vm._s(_vm.distance) + " miles\n")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }